import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-get-invloved',
  templateUrl: './get-invloved.component.html',
  styleUrls: ['./get-invloved.component.scss']
})
export class GetInvlovedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
